import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="trash-a"
            d="M11,3 L16,3 L16,4 L0,4 L0,3 L5,3 L5,1 C5,0.448 5.448,0 6,0 L10,0 C10.552,0 11,0.448 11,1 L11,3 Z M3.944,11 L7,11 L7,12 L4.1,12 L4.492,14.519 C4.534,14.788 4.746,14.977 4.985,14.977 L11.015,14.977 C11.254,14.977 11.466,14.788 11.508,14.519 L13.006,4.943 L14,4.943 L12.496,14.673 C12.38,15.42 11.756,15.977 11.015,15.977 L4.985,15.977 C4.244,15.977 3.62,15.42 3.504,14.673 L1.993,4.943 L9,4.943 L9,5.95 L3.157,5.95 L3.476,8 L8,8 L8,9 L3.632,9 L3.944,11 Z M6,3 L10,3 L10,1 L6,1 L6,3 Z"/>
    </defs>
    <g>
      <use xlinkHref="#trash-a"/>
    </g>
  </svg>
);
